import './styles/graphic.scss';
import * as d3 from 'd3';


function updateData() {
  getCurrentKyivTime();


  d3.json('https://ix.cnn.io/data/kyiv-air-alerts/latest.json').then((data) => {
    const { current } = data;

    const today_count = data.today.alertCount;

    // DEBUGGING ONLY
    // current.active = false;
    // current.active = true;
    // today_count = 0;

    document.getElementsByClassName('status-container')[0].classList.toggle('alert-active', current.active);


    const alert_status = current.active === true ? 'ACTIVE AIR RAID ALERT' : 'NO AIR RAID ALARM';
    document.getElementById('alert-status').innerHTML = alert_status;
    document.getElementById('alert-status').classList.toggle('active', current.active);

    if (current.active) {
      document.getElementById('alert-status-text').innerHTML = data.summaryHtml;
    } else if (today_count > 0) {
      document.getElementById('alert-status-text').innerHTML = data.alertsTodayHtml;
    } else {
      document.getElementById('alert-status-text').innerHTML = 'There have been no air raid alerts today';
    }

    // DEBUGGING ONLY
    // document.getElementById('alert-status-text').innerHTML = 'There is currently an air raid alert active in Kyiv';

    if (today_count > 0) {
      if (current.active) {
        document.getElementById('alerts-today').innerHTML = data.alertsTodayHtml;
      } else {
        document.getElementById('alerts-today').innerHTML = '';
      }
    } else {
      document.getElementById('alerts-today').innerHTML = '';
    }

    document.getElementById('alerts-total').innerHTML = data.alertsTotalHtml;

    document.getElementById('last-updated').textContent = data.lastUpdatedStr;


    if (window.pymChild) {
      window.pymChild.sendHeight();
    }
  });
}

function getCurrentKyivTime() {
  const now = new Date();
  const opts = { hour: 'numeric', minute: '2-digit', timeZone: 'Europe/Kyiv' };

  document.getElementById('kyiv-time').textContent = new Intl.DateTimeFormat('en-US', opts).format(now);
}

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
    // width,
    // height
  } = props;

  updateData();
}

setInterval(updateData, 20000);
